import { ModelRow, StringUtil, UrlUtil } from "@mcleod/core";
import { AutogenLayoutDetentionHistoryList } from "./autogen/AutogenLayoutDetentionHistoryList";
import { BlurEvent, ChangeEvent, Checkbox, DataSourceAction, DataSourceExecutionEvent, DropdownItem, LookupModelSearchEvent, LookupModelSelectionEvent, Textbox } from "@mcleod/components";
import { ModelDetentionProfile } from "./models/ModelDetentionProfile";
import { DetentionDefaults } from "./DetentionDefaults";
import { LMEUserSettings } from "@mcleod/general";

export class DetentionHistoryList extends AutogenLayoutDetentionHistoryList {

    onLoad(): void | Promise<void> {
        const urlParams = UrlUtil.getPropsFromUrl(window.location.href);
        if (urlParams?.type) {
            this.autoSearchByType(urlParams);
        } else {
            const userDefaults = LMEUserSettings.get()?.detention_profile;
            if (userDefaults) {
                this.defaultSearch(userDefaults).then(() => {
                    if (urlParams?.status) {
                        const statuses = urlParams.status.split("|").map((s: string) => s.trim());
                        this.setDropdownSelectionByFilter(this.textboxStatusSearch, (item) => statuses.includes(item.value));
                    }
                    this.mainDataSource.executeValidatedSearch();
                });
            }
        }
    }

    textboxAuthorizationNumSearchOnBlur(event: BlurEvent) {
        if (!StringUtil.isEmptyString(this.textboxAuthorizationNumSearch.text)){
            this.checkboxAuthNumBlank.checked = undefined;
        }
    }

    checkboxAuthNumBlankOnChange(event: ChangeEvent) {
        if (event.newValue === undefined) {
            this.textboxAuthorizationNumSearch.enabled = true;
        } else {
            this.textboxAuthorizationNumSearch.enabled = false;
            this.textboxAuthorizationNumSearch.text = null;
        }
    }

    textboxDefaultsOnLookupModelSelection(event: LookupModelSelectionEvent){
        if (event.hasSelection()) {
            const selected = event.selection;
            this.defaultSearch(selected.getString("id"));
        }
    }

    textboxDefaultsBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.web_valid = true;
    }

    sourceDetentionHistoryLookupBeforeExecution(event: DataSourceExecutionEvent) {
        if (DataSourceAction.SEARCH === event.getAction()) {
            if (this.checkboxAuthNumBlank.checked !== undefined) {
                event.filter.authorization_num = this.checkboxAuthNumBlank.checked ? "=" : "*";
            } else if (!StringUtil.isEmptyString(this.textboxAuthorizationNumSearch.text)) {
                event.filter.authorization_num = this.textboxAuthorizationNumSearch.text;
            }
        }
    }

    defaultSearch(defaultId: string): Promise<void> {
        this.searchpanelDetention.forEveryChildComponent((component) => {
            if (component instanceof Textbox && component.id !== this.textboxDefaults.id) {
                component.text = null;
                component.clear();
            } else if (component instanceof Checkbox) {
                component.checked = undefined;
            }
        });
        return new ModelDetentionProfile().searchSingle({'id': defaultId})
        .then((result: ModelRow) => DetentionDefaults.mapDefaultsToHistorySearch(result, this));
    }

    autoSearchByType(urlParams: any) {
        const filter: any = {};
        switch (urlParams.type) {
            case "L":
                filter.stop_location_id = urlParams.stop_location_id;
                filter.status = urlParams.status;
                filter.creation_date = urlParams.creation_date;
                this.textboxStopLocationId.lookupModelData
                this.mainDataSource.searchRow.setValueAndLookupModelData(
                    "stop_location_id", urlParams.stop_location_id, {
                        name: urlParams.stop_location_name || "",
                        id: urlParams.stop_location_id
                    });
                this.mainDataSource.displayDataInBoundSearchComponent(this.textboxStopLocationId);
                break;
            case "D":
                filter.detention_def_id = urlParams.detention_def_id;
                filter.status = urlParams.status;
                filter.creation_date = urlParams.creation_date;
                break;
            case "C":
                filter.customer_id = urlParams.customer_id;
                filter.status = urlParams.status;
                filter.creation_date = urlParams.creation_date;
                this.mainDataSource.searchRow.setValueAndLookupModelData(
                    "customer_id", urlParams.customer_id, {
                        name: urlParams.customer_name || "",
                        id: urlParams.customer_id
                    });
                this.mainDataSource.displayDataInBoundSearchComponent(this.textboxCustomerIdSearch);
                break;
        }
        if (urlParams.creation_date) {
            this.populateCreationDateFilter(urlParams.creation_date);
        }
        this.setDropdownSelectionByFilter(this.textboxStatusSearch, (item) => item.value !== "V");
        this.mainDataSource.search(filter);
    }

    populateCreationDateFilter(filterString: string) {
        const dates = filterString.split("&").map((date) => date.trim().substring(2));
        this.textboxCreationDateSearch.text = `${dates[0]} - ${dates[1]}`;
    }

    setDropdownSelectionByFilter(tb: Textbox, predicate: (item: DropdownItem) => boolean) {
        const tbItems = typeof tb.items === "function" ? tb.items() : tb.items;
        tb.selectedItems = tbItems.map(item =>
                typeof item === "string" ? new DropdownItem(item) : item
            ).filter(predicate);
    }
}
